var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTreeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69.2 100",
    style: {
      enableBackground: "new 0 0 69.2 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#58843D;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,50.2c-4.6,1.2-8.1,2.1-12.2,3.2c4.8-7.6,9.3-14.6,14.3-22.5c-3.2,0.3-5.6,0.6-8.8,0.9 c7.2-10.7,14-21,21.2-31.8c7.1,10.7,14,21,21.2,31.8c-3.3-0.3-5.9-0.6-8.8-0.9c4.8,7.5,9.3,14.6,14.4,22.5c-4.3-1.1-7.7-2-12.1-3.1 c6.7,10.7,13,20.6,19.9,31.6c-10.6-1.9-20.1-3.7-30-5.5c0,8,0,15.6,0,23.5c-3,0-5.8,0-9,0c0-7.7,0-15.4,0-23.5 C20,78.3,10.4,79.9,0,81.7C6.9,70.9,13.2,60.9,20,50.2z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTreeIcon);
export default __webpack_public_path__ + "static/media/tree-icon.b72b86664cef941fb1486dbaf8420231.svg";
export { ForwardRef as ReactComponent };